//保全须知
const preservationNotice = () => import('../views/applyPreservation/preservationNotice')
//创建保全
const createPreservation = () => import('../views/applyPreservation/createPreservation')
//创建保全时选择法院
const selectBqCourt = () => import('../views/applyPreservation/selectCourt')
//保全基本信息
const preservationInfo = () => import('../views/applyPreservation/preservationInfo')
//编辑基本信息页面
const editBasic = () => import('../views/applyPreservation/editPreservation/editBasic')
//保全详情
const preservationDetail = () => import('../views/applyPreservation/preservationDetail')
//添加申请人
const addBqSQR = () => import('../views/applyPreservation/addPreservation/addSQR')
//添加被申请人
const addBqBSQR = () => import('../views/applyPreservation/addPreservation/addBSQR')
//添加财产线索
const addBqCcxs = () => import('../views/applyPreservation/addPreservation/addCCXS')
//添加财产线索
const addBqZjxx = () => import('../views/applyPreservation/addPreservation/addZJXX')
//添加财产线索
const addBqXwxx = () => import('../views/applyPreservation/addPreservation/addXWXX')

//添加原告代理人
const addBqYGDLR = () => import('../views/applyPreservation/addPreservation/addYGDLR')
//添加财产线索
const addBqCCXS = () => import('../views/applyPreservation/addPreservation/addCCXS')
//添加申请财产查控
const addBqCCCK = () => import('../views/applyPreservation/addPreservation/addCCCK')
//编辑申请人
const editBqSQR = () => import('../views/applyPreservation/addPreservation/addSQR')
//编辑被申请人
const editBqBsqr = () => import('../views/applyPreservation/addPreservation/addBSQR')
//编辑原告代理人
const editBqYgdlr = () => import('../views/applyPreservation/addPreservation/addYGDLR')
//原告代理人页面获取所属原告
const getBqSsygList = () => import('../views/applyPreservation/addPreservation/getSsygList')
//保全中添加担保信息
const addBqDbxx = () => import('../views/applyPreservation/addPreservation/addBqDbxx')
//保全交费
const preservationpay = () => import('../views/applyPreservation/preservationPay')
//解除保全
const relievePreservation = () => import('../views/applyPreservation/relievePreservation')
//解除保全新版
const relievePreservationNew = () => import('../views/applyPreservation/relievePreservationNew')
//解除保全详情
const relievePreservationDetail = () => import('../views/applyPreservation/relievePreservationDetail')
//续行保全
const continuationPreservation = () => import('../views/applyPreservation/continuationPreservation')
//续行保全新版
const continuationPreservationNew = () => import('../views/applyPreservation/continuationPreservationNew')
//续行保全详情页
const continuationPreservationDetail = () => import('../views/applyPreservation/continuationPreservationDetail')

//解除保全添加财产线索
const JcaddBqCcxs = () => import('../components/releasePreservation/itemPopover/addCCXS')
//解除保全全添加证据信息
const JcaddBqZjxx = () => import('../components/releasePreservation/itemPopover/addZJXX')
//解除保全添加行为信息
const JcaddBqXwxx = () => import('../components/releasePreservation/itemPopover/addXWXX')
// 解保审查信息详情
const JcscxxDeatil = () => import('../components/releasePreservation/itemPreview/scxxDeatil')
//解除保全时选择法院
const selectBqCourtJc = () => import('../components/releasePreservation/selectCourtJc')
//续行保全添加财产线索
const XxaddBqCcxs = () => import('../components/continuationPreservation/itemPopover/addCCXS')
//续行保全添加证据信息
const XxaddBqZjxx = () => import('../components/continuationPreservation/itemPopover/addZJXX')
// 续行审查信息详情
const XxscxxDeatil = () => import('../components/continuationPreservation/itemPreview/scxxDeatil')
//续行保全添加行为信息
const XxaddBqXwxx = () => import('../components/continuationPreservation/itemPopover/addXWXX')
//续行保全中添加担保信息
const XxaddBqDbxx = () => import('../components/continuationPreservation/itemPopover/addBqDbxx')
//解除保全时选择法院
const selectBqCourtXx = () => import('../components/continuationPreservation/selectCourtXx')
export default [
    {
        path: '/relievePreservation',
        name: 'relievePreservation',
        meta: {
            title: '在线保全-申请解保',
        },
        component: relievePreservation
    },
    {
        path: '/continuationPreservation',
        meta: {
            title: '在线保全-申请续保',
        },
        component: continuationPreservation
    },
    {
        path: '/relievePreservationNew',
        name: 'relievePreservationNew',
        meta: {
            title: '在线保全-申请解保',
        },
        component: relievePreservationNew
    },
    {
        path: '/relievePreservationDetail',
        name: 'relievePreservationDetail',
        meta: {
            title: '在线保全-解保详情',
        },
        component: relievePreservationDetail
    },
    {
        path: '/continuationPreservationNew',
        meta: {
            title: '在线保全-申请续行',
        },
        component: continuationPreservationNew
    },
    {
        path: '/continuationPreservationDetail',
        name: 'continuationPreservationDetail',
        meta: {
            title: '在线保全-续保详情',
        },
        component: continuationPreservationDetail
    },
    {
        path: '/preservationNotice',
        name: 'preservationNotice',
        component: preservationNotice,
        meta: {
            title: '在线保全-保全须知',
        },
    },
    {
        path: '/createPreservation',
        name: 'createPreservation',
        component: createPreservation,
        meta: {
            title: '在线保全-申请保全',
            keepAlive: true // 需要被缓存
        },
    },
    {
        path: '/selectBqCourt',
        name: 'selectBqCourt',
        component: selectBqCourt,
        meta: {
            title: '在线保全-请选择法院',
        },
    },
    {
        path: '/preservationInfo',
        name: 'preservationInfo',
        component: preservationInfo,
        meta: {
            title: '在线保全-申请保全',
            keepAlive: true // 需要被缓存
        },
    },
    {
        path: '/editBasic',
        name: 'editBasic',
        component: editBasic,
        meta: {
            title: '在线保全-申请保全',
        },
    },
    {
        path: '/preservationDetail',
        name: 'preservationDetail',
        component: preservationDetail,
        meta: {
            title: '在线保全-保全详情'
        },
    },
    {
        path: '/addBqSQR',
        name: 'addBqSQR',
        component: addBqSQR,
        meta: {
            title: '在线保全-申请人'
        },
    },
    {
        path: '/addBqBSQR',
        name: 'addBqBSQR',
        component: addBqBSQR,
        meta: {
            title: '在线保全-被申请人'
        },
    },
    {
        path: '/addBqCcxs',
        name: 'addBqCcxs',
        component: addBqCcxs,
        meta: {
            title: '在线保全-财产线索'
        }
    },
    // 证据信息
    {
        path: '/addBqZjxx',
        name: 'addBqZjxx',
        component: addBqZjxx,
        meta: {
            title: '在线保全-证据信息'
        }
    },
    {
        path: '/addBqXwxx',
        name: 'addBqXwxx',
        component: addBqXwxx,
        meta: {
            title: '在线保全-行为信息'
        }
    },
    {
        path: '/addBqYGDLR',
        name: 'addBqYGDLR',
        component: addBqYGDLR,
        meta: {
            title: '在线保全-原告代理人',
        },
    },
    {
        path: '/addBqCCXS',
        name: 'addBqCCXS',
        component: addBqCCXS,
        meta: {
            title: '在线保全-财产线索'
        },
    },
    {
        path: '/addBqCCCK',
        name: 'addBqCCCK',
        component: addBqCCCK,
        meta: {
            title: '在线保全-申请财产查控'
        },
    },
    {
        path: '/editBqSQR',
        name: 'editBqSQR',
        component: editBqSQR,
        meta: {
            title: '在线保全-申请人'
        },
    },
    {
        path: '/editBqBsqr',
        name: 'editBqBsqr',
        component: editBqBsqr,
        meta: {
            title: '在线保全-被申请人'
        },
    },
    {
        path: '/editBqYgdlr',
        name: 'editBqYgdlr',
        component: editBqYgdlr,
        meta: {
            title: '在线保全-原告代理人'
        },
    },
    {
        path: '/getBqSsygList',
        name: 'getBqSsygList',
        component: getBqSsygList,
        meta: {
            title: '在线保全-所属原告',
            // keepAlive: true // 需要被缓存
        },
    },
    {
        path: '/addBqDbxx',
        name: 'addBqDbxx',
        component: addBqDbxx,
        meta: {
            title: '在线保全-担保信息'
        }
    },
    {
        path: '/preservationpay',
        name: 'preservationpay',
        component: preservationpay,
        meta: {
            title: '在线保全-交费'
        }
    },
    // 解除保全
    {
        path: '/JcaddBqCcxs',
        name: 'JcaddBqCcxs',
        component: JcaddBqCcxs,
        meta: {
            title: '在线保全-添加财产线索'
        }
    },
    // 证据信息
    {
        path: '/JcaddBqZjxx',
        name: 'JcaddBqZjxx',
        component: JcaddBqZjxx,
        meta: {
            title: '在线保全-添加行为信息'
        }
    },
    {
        path: '/JcaddBqXwxx',
        name: 'JcaddBqXwxx',
        component: JcaddBqXwxx,
        meta: {
            title: '在线保全-添加行为信息'
        }
    },
    // 审查信息
    {
        path: '/JcscxxDeatil',
        name: 'JcscxxDeatil',
        component: JcscxxDeatil,
        meta: {
            title: '在线保全-解保审查信息'
        }
    },
    {
        path: '/selectBqCourtJc',
        name: 'selectBqCourtJc',
        component: selectBqCourtJc,
        meta: {
            title: '解除在线保全-选择法院',
        },
    },
    {
        path: '/selectBqCourtXx',
        name: 'selectBqCourtXx',
        component: selectBqCourtXx,
        meta: {
            title: '续行在线保全-选择法院',
        },
    },
    // 续行保全
    {
        path: '/XxaddBqCcxs',
        name: 'XxaddBqCcxs',
        component: XxaddBqCcxs,
        meta: {
            title: '在线保全-添加财产线索'
        }
    },
    // 证据信息
    {
        path: '/XxaddBqZjxx',
        name: 'XxaddBqZjxx',
        component: XxaddBqZjxx,
        meta: {
            title: '在线保全-添加行为信息'
        }
    },
    // 审查信息
    {
        path: '/XxscxxDeatil',
        name: 'XxscxxDeatil',
        component: XxscxxDeatil,
        meta: {
            title: '在线保全-解保审查信息'
        }
    },
    {
        path: '/XxaddBqDbxx',
        name: 'XxaddBqDbxx',
        component: XxaddBqDbxx,
        meta: {
            title: '在线保全-添加担保信息'
        }
    },
    {
        path: '/XxaddBqXwxx',
        name: 'XxaddBqXwxx',
        component: XxaddBqXwxx,
        meta: {
            title: '在线保全-添加行为信息'
        }
    },
]
